require('../../modules/es6.object.keys');
module.exports = require('../../modules/_core').Object.keys;



//////////////////
// WEBPACK FOOTER
// ../js/~/core-js/library/fn/object/keys.js
// module id = 636
// module chunks = 0